import { Suspense, useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import orderServices from '../../services/orders/orderservice';
import { OrderModel } from '../../models/orders/order-list-model';
import { DataTableStateEvent } from "primereact/datatable";
import { Toast } from 'primereact/toast';
import GenerateInvoiceSearch from './new-generate-invoice-search';
import GenerateInvoiceDataTable from './new-generate-invoice-datatable';

const GenerateInvoiceList = () => {
    const { t } = useTranslation();
    const toast = useRef<Toast>(null);
    const [orderList, setOrderList] = useState<OrderModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [orderIds,setOrderIds] = useState<any>();

    const currentFilters = useRef<{
        startDate?: Date;
        endDate?: Date;
        orderId?: number;
        userId?: number;
        pageNumber?: number;
        pageSize?: number;
    }>({});

    const FeatchOrderIds = async () => {
        await  orderServices.GetPullPaymentStatusLogs().then((orderIdList: any[]) => {
        setOrderIds(orderIdList);
    });
    }
    useEffect(() => {
        const loadInitialData = async () => {
            const initialFilters = {
                pageNumber: 1,
                pageSize: 10,
                resetPagination: false
            };
            await handleSearch(initialFilters);
        };

        loadInitialData();
        FeatchOrderIds();
    }, []);

    const handleSearch = async (filters: {
        startDate?: Date;
        endDate?: Date;
        orderId?: number;  
        userId?: number;   
        pageNumber?: number;
        pageSize?: number;
        resetPagination?: boolean;  
    }) => {
        setLoading(true);
        setHasSearched(true);
        currentFilters.current = filters;
            
        const shouldResetPagination = filters.resetPagination;
        const currentPageNumber = shouldResetPagination ? 1 : filters.pageNumber || pageNumber;
        const currentPageSize = shouldResetPagination ? 10 : filters.pageSize || pageSize;
        
        try {
            const requestBody = {
                startDate: filters.startDate,
                endDate: filters.endDate,
                orderId: filters.orderId,
                userId: filters.userId,
                pageNumber: currentPageNumber,
                pageSize: currentPageSize
            };

            if (shouldResetPagination) {
                setPageNumber(1);
                setPageSize(10);
            }  
            
            const response = await orderServices.GenerateInvoiceDetails(requestBody); 
            setOrderList(response.data);
            setTotalRecords(response.totalCount || 0);
        } catch (error) {
            console.error('Error fetching orders:', error);
            setOrderList([]);
            setTotalRecords(0);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to fetch orders',
                life: 3000
            });
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setOrderList([]);
        setTotalRecords(0);
        setHasSearched(false);
        setPageNumber(1);
        setPageSize(10);
        currentFilters.current = {};
        return {};
    };

    const handlePageChange = (event: DataTableStateEvent) => {
        const newPageNumber = Math.floor((event.first || 0) / (event.rows || 10)) + 1;
        const newPageSize = event.rows || 10;
       
        setPageNumber(newPageNumber);
        setPageSize(newPageSize);
       
        handleSearch({
            ...currentFilters.current,
            pageNumber: newPageNumber,
            pageSize: newPageSize,
            resetPagination: false 
        });
    };

    const refreshData = async () => {
        await handleSearch({
            ...currentFilters.current,
            pageNumber,
            pageSize,
            resetPagination: false
        });
    };

    return (
        <Suspense>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">                
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">Generate Invoice</h5>                      
                    </div> 
                </div>
                <GenerateInvoiceSearch
                    onSearch={handleSearch}
                    setLoading={setLoading}
                    onReset={handleReset}
                />            
               
                <GenerateInvoiceDataTable
                    data={orderList}
                    pageNumber={pageNumber}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={handlePageChange}
                    onRefresh={refreshData}
                />        
            </div>
        </Suspense>
    );
};

export default GenerateInvoiceList;